// Public URLs determine the language, including visits from search engines.
// Account preferences apply only inside the authenticated application.
export default async function ({ app, route, $auth }) {
  const isPublicPage = route.matched.some(({ components }) =>
    Object.values(components).some(component => {
      const options = component.options || component
      return options.auth === false || options.auth === 'guest'
    })
  )
  const language = $auth.user && $auth.user.lang

  if (!isPublicPage && ['pl', 'en'].includes(language) && language !== app.i18n.locale) {
    await app.i18n.setLocale(language)
  }
}
